import { useEffect, useState } from "react";
import advanceOutstandingApi from "../api/advanceOutstandingApi";
import T from "../theme/colors";

// What the picked employee / contractor already owes, bucket by bucket, shown
// under the advance form so the person giving more can see it first. The
// bucket being recorded is highlighted. Quietly shows nothing when the user
// may not read it or when nothing is outstanding.
export const ADVANCE_TYPE_LABEL = {
  ADVANCE: "Advance", LOAN: "Loan / Baki", MACHINERY: "Machinery", PURCHASE: "Purchase",
  PF: "PF", ESI: "ESI", PT: "PT",
};

const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export default function AdvanceOutstandingChips({ partyType, partyId, highlight, refreshKey }) {
  const [row, setRow] = useState(null);

  useEffect(() => {
    let alive = true;
    setRow(null);
    if (!partyType || !partyId) return undefined;
    advanceOutstandingApi.forParty(partyType, partyId)
      .then(r => {
        const list = r?.data?.data;
        if (alive) setRow(Array.isArray(list) && list.length ? list[0] : { buckets: {}, total: 0 });
      })
      .catch(() => { if (alive) setRow(null); });
    return () => { alive = false; };
  }, [partyType, partyId, refreshKey]);

  if (!row) return null;
  const entries = Object.entries(row.buckets || {}).filter(([, v]) => Number(v) > 0);
  return (
    <div style={{ marginTop: 6, display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center", fontSize: 12 }}>
      <span style={{ color: T.text2, fontWeight: 600 }}>Outstanding:</span>
      {entries.length === 0 ? <span style={{ color: T.text2 }}>nothing</span> : entries.map(([k, v]) => (
        <span key={k} style={{
          padding: "2px 8px", borderRadius: 999, fontWeight: 700,
          border: `1px solid ${k === highlight ? "#F59E0B" : T.border}`,
          background: k === highlight ? "#FEF3C7" : T.bgHover,
          color: k === highlight ? "#92400E" : T.text1,
        }}>{ADVANCE_TYPE_LABEL[k] || k} {inr(v)}</span>
      ))}
    </div>
  );
}
